import { DraftConfiguration, DraftState } from '@/types';
import { getViewFromConfiguration } from '@/model/configuration/getViewFromConfiguration';
import { isDraftConfigurationWithTextOrSpecialText } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { getProductType } from '@/model/draft/getProductType';
import { getSelectedConfiguration } from '@/model/draft/getSelectedConfiguration';
import { removeConfiguration } from './helper/removeConfiguration';

export const setSelectedConfigurationAction =
  ({ cid }: DraftConfiguration = { cid: -1 } as DraftConfiguration) =>
  (draft: DraftState) => {
    if (cid !== draft.selectedConfigurationId) {
      const selectedConfiguration = getSelectedConfiguration(draft);
      if (isDraftConfigurationWithTextOrSpecialText(selectedConfiguration)) {
        if (/^[\s\n\r]*$/.test(selectedConfiguration.text.content)) {
          removeConfiguration(draft, cid);
        }
      }

      const configuration = getConfiguration(draft, cid);
      if (configuration) {
        draft.selectedConfigurationId = cid;

        const view = getViewFromConfiguration(getProductType(draft), configuration);
        if (draft.view !== view) {
          draft.view = view;
        }
      } else {
        draft.selectedConfigurationId = -1;
      }
    }
  };
